module.exports = __webpack_public_path__ + "img/4.729cd431.png";